import React  from "react";
import Layout from "../components/Layout";
import Welcome from "../components/Welcome";

const Home =()=>{
    return(
        <Layout>
            <Welcome/>
        </Layout>
    );
}
export default Home;
